import { StoreCore, createStore } from "@priolo/jon";
import { Solution } from "types/Production";



/**
 * Gestione SOLUTIONS del LAB PLANNER
 */
const setup = {

	state: {
		/** la SOLUTION selezionata che contiene i dati da visualizzare nel PLANNER */
		selected: <Solution>null,
	},

	getters: {

	},

	actions: {

	},

	mutators: {
		setSelected: (selected: Solution) => ({ selected }),
	},
}



export type SolutionLabState = typeof setup.state
export type SolutionLabGetters = typeof setup.getters
export type SolutionLabActions = typeof setup.actions
export type SolutionLabMutators = typeof setup.mutators
export interface SolutionLabStore extends StoreCore<SolutionLabState>, SolutionLabGetters, SolutionLabActions, SolutionLabMutators {
	state: SolutionLabState
}
const solutionLabSo = createStore(setup) as SolutionLabStore
export default solutionLabSo
